export default __webpack_public_path__ + "static/booking-completed-d80111a6d56b1aeeb0943a0b0ac8d2fa.png";